import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ProfileOutputComponent } from './profile-output.component';
import { SharedModule } from '../../shared/shared.module';
import { CitationsModule } from '../../parts/citations/citations.module';
import { ButtonSplashComponent } from '../../bits/button-splash/button-splash.component';
import { ExpandableTextModule } from '../../parts/expandable-text/expandable-text.module';
import { RouterModule } from '@angular/router';
import { ProfileOutputGroupComponent } from '../profile-output-group/profile-output-group.component';
import { ChatModule } from '../../parts/chat/chat.module';
import { BadgeModule } from '../../bits/badge/badge.module';

import { NgxPaginationModule } from 'ngx-pagination';
import { DiscoveryToolbarModule } from '../../discovery/discovery-toolbar/discovery-toolbar.module';
import {
    BreadcrumbsNavComponent,
    ExpandableComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarComponent,
    FloatingToolbarSeparatorComponent,
    FunkyButtonComponent,
    PagingComponent,
    SeparatorComponent,
    StatusTagComponent,
    UrlTrustPipe,
    VerticalTabsDirective,
} from '@exl-ng/mulo-common';
import { NavMainLayoutComponent } from '@exl-ng/mulo-views';
import { ContentLoaderModule } from '@ngneat/content-loader';

@NgModule({
    imports: [
    SharedModule,
    CitationsModule,
    ButtonSplashComponent,
    ExpandableTextModule,
    RouterModule,
    ContentLoaderModule,
    ChatModule,
    BadgeModule,
    FunkyButtonComponent,
    NgxPaginationModule,
    PagingComponent,
    DiscoveryToolbarModule,
    BreadcrumbsNavComponent,
    NavMainLayoutComponent,
    StatusTagComponent,
    ExpandableComponent,
    SeparatorComponent,
    FloatingToolbarComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarSeparatorComponent,
    UrlTrustPipe,
    VerticalTabsDirective,
    ProfileOutputComponent, ProfileOutputGroupComponent,
],
    exports: [ProfileOutputComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProfileOutputModule {}
